import React from "react";
const GetValidityMonth = () => {
  // return a group of options from 0 to 11
  const child = [];
  for (var i = 1; i < 13; i++)
    child.push(
      <option key={i} value={`${i}`}>
        {i}
      </option>
    );
  return child;
};

export default React.memo(GetValidityMonth);
